import { createFileRoute } from '@tanstack/react-router';
import { AntifraudPage } from '@/pages/AntifraudPage';

export const Route = createFileRoute('/_authed/antifraud')({
  component: AntifraudPage,
});
